{
  "members.invite.allMembers": "All members",
  "members.invite.body": "Invite your team members and assign permissions and roles.",
  "members.invite.error.title": "Error message",
  "members.invite.failed": "Invite failed",
  "members.invite.heading": "Invite team members",
  "members.invite.loadFailed": "Could not load members.",
  "members.invite.members": "Members",
  "members.invite.membersCount": "Members · {count}",
  "members.invite.offline": "Could not reach the server. Check your connection and try again.",
  "members.invite.onlyYou": "Only you so far.",
  "members.invite.retry": "Try again",
  "members.invite.success.message": "User '{name}' has been successfully invited",
  "members.invite.success.title": "Success message",
  "members.invite.validation.message": "Please fill in all fields",
  "members.invite.validation.title": "Validation message",
  "members.inviteDropdown.copyLink": "Copy invite link",
  "members.inviteDropdown.linkCopied.title": "Link copied",
  "members.inviteDropdown.magicLink.active": "Active links",
  "members.inviteDropdown.magicLink.copy": "Copy magic link",
  "members.inviteDropdown.magicLink.created": "Link copied — the first person who opens it joins as {role}. Ends {date}.",
  "members.inviteDropdown.magicLink.creating": "Creating…",
  "members.inviteDropdown.magicLink.failed": "Could not create the link",
  "members.inviteDropdown.magicLink.hint": "The first person who opens it joins as {role}. It works once.",
  "members.inviteDropdown.magicLink.hintDays": "The first person who opens it joins as {role}. It works once. It ends in {days} days.",
  "members.inviteDropdown.magicLink.hintOneDay": "The first person who opens it joins as {role}. It works once. It ends in 1 day.",
  "members.inviteDropdown.magicLink.loadFailed": "Could not load the active links.",
  "members.inviteDropdown.magicLink.notCopied": "Link created, but it could not be copied. Revoke it and try again.",
  "members.inviteDropdown.magicLink.revoke": "Revoke",
  "members.inviteDropdown.magicLink.revokeFailed": "Could not revoke the link",
  "members.inviteDropdown.magicLink.revokeLabel": "Revoke the {role} link that ends {date}",
  "members.inviteDropdown.magicLink.revoked": "Link revoked. Nobody can join with it now.",
  "members.inviteDropdown.magicLink.revoking": "Revoking…",
  "members.inviteDropdown.magicLink.row": "{role} · Ends {date}",
  "members.inviteDropdown.magicLink.title": "Share by magic link",
  "members.inviteDropdown.magicLink.tooMany": "Revoke an open link first.",
  "members.inviteDropdown.noPermission": "Only admins can invite people here. Ask an admin to send the invite.",
  "members.inviteDropdown.personalOrg": "A personal organization holds only you. Invite people to a team organization.",
  "members.inviteDropdown.sentNoEmail": "Invite created for {email}, but the email did not go out. Copy the link and send it yourself.",
  "members.inviteDropdown.title": "Invite members",
  "members.inviteForm.emailLabel": "Email",
  "members.inviteForm.emailOfMember": "Email of member",
  "members.inviteForm.fullName": "Full name",
  "members.inviteForm.invalidEmail": "Enter a valid email address.",
  "members.inviteForm.needEmail.message": "Type an email address to invite.",
  "members.inviteForm.placeholder": "Type email to invite",
  "members.inviteForm.roleOfMember": "Role of member",
  "members.inviteForm.send": "Send invite",
  "members.inviteForm.sending": "Sending…",
  "members.inviteSent.person": "Invited {who}",
  "members.navbar.invite": "Invite Members",
  "members.notify.error.title": "Error message",
  "members.notify.success.title": "Success message",
  "members.persona.exit": "Exit",
  "members.persona.exiting": "Exiting…",
  "members.persona.role.admin": "Admin",
  "members.persona.role.guest": "Guest",
  "members.persona.role.teamMember": "Team member",
  "members.persona.viewAs": "View as",
  "members.persona.viewAsRole": "View as {role}",
  "members.requestAccess.body": "We're kicking off invite-only. Get early signup to make it to the top.",
  "members.requestAccess.continueEmail": "Continue with email",
  "members.requestAccess.title": "Get early access",
  "members.role.admin": "Admin",
  "members.role.changeFailed": "Role change failed",
  "members.role.coOwner": "Co-owner",
  "members.role.contributor": "Contributor",
  "members.role.editor": "Member",
  "members.role.guest": "Guest",
  "members.role.maintainer": "Maintainer",
  "members.role.member": "Member",
  "members.role.owner": "Owner",
  "members.role.viewer": "Contributor",
  "members.roleUpdated.fallbackName": "Member",
  "members.roleUpdated.message": "{name} is now {role}",
  "members.roleUpdated.title": "Role updated",
  "members.share.canvasLink": "Canvas link",
  "members.share.copyUrl": "Copy URL",
  "members.share.env.current": "Current",
  "members.share.env.development": "Development",
  "members.share.env.production": "Production",
  "members.share.env.staging": "Staging",
  "members.share.environment": "Environment",
  "members.share.environmentHint": "Inherint or switch while sharing",
  "members.share.openNewTab": "Open in new tab",
  "members.share.previewLink": "Preview link",
  "members.share.selection": "Selection share",
  "members.share.selectionHint": "Link to selected element on canvas",
  "members.share.title": "Share",
  "members.sharing.canvasAccess": "Canvas access",
  "members.sharing.canvasHint": "Control access to the canvas",
  "members.sharing.passwordProtected": "Password protected",
  "members.sharing.previewHint": "Control access to the preview links",
  "members.sharing.previewVisibility": "Preview visibility",
  "members.sharing.private": "Private",
  "members.sharing.public": "Public",
  "members.sharing.title": "Access Permissions",
  "members.sharing.unlisted": "Unlisted",
  "members.sharingNavbar.newTab": "In new tab",
  "members.sharingNavbar.share": "Share",
  "members.table.actions": "Actions",
  "members.table.confirmRole": "Confirm role change",
  "members.table.editRole": "Edit role",
  "members.table.email": "Email",
  "members.table.empty": "No team members found.",
  "members.table.name": "Name",
  "members.table.removeMember": "Remove member",
  "members.table.role": "Role",
  "members.usersTable.heading": "Team Members",
  "members.usersTable.invite": "Invite new member",
  "members.usersTable.title": "Team Members:"
}
